<template>
    <div id="login-page">
      <div v-if="currentForm === 'login'" class="login-container">
        <div class="logo-container">
          <img src="https://sander-gruppe.eu/wp-content/uploads/2019/07/ms-logo.png" alt="Ihr Logo" class="logo">
        </div>
        <div class="outer-container">
          <ForgotPassword ref="forgotPasswordComponent" v-show="menuState == 1"/>
          <FirstUserPassword v-show="menuState == 2"/>
          <div v-show="menuState == 0">
            <h3>m&s Elemente Konfigurator - Login</h3>
            <div v-if="loginError" class="error-message">
                Das Einloggen war nicht möglich. Bitte überprüfen Sie Ihre Eingaben.
            </div>
            <div v-if="blockedError" class="error-message">
                Dieser Benutzer ist blockiert. Bitte wenden Sie sich an den Support.
            </div>
            <form @submit.prevent="login">
              <div class="inner-container">
                <div class="inner-left-container">
                  <div class="input-container">
                    <label for="kdnr">Kundennummer:</label>
                    <input id="kdnr" type="text" v-model="kdnr" required>
                  </div>
                  <div class="input-container">
                    <label for="email">E-Mail:</label>
                    <input id="email" type="email" v-model="email" required>
                  </div>
                  <div class="input-container">
                    <label for="password">Passwort:</label>
                    <div class="password-wrapper">
                      <input
                        id="password"
                        :type="showPassword ? 'text' : 'password'"
                        v-model="password"
                        required
                        @keyup.enter="login"
                      >
                      <button
                        type="button"
                        class="eye-toggle"
                        @click="showPassword = !showPassword"
                        :aria-label="showPassword ? 'Passwort verbergen' : 'Passwort anzeigen'"
                      >
                        <svg v-if="!showPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#747474" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/>
                          <circle cx="12" cy="12" r="3"/>
                        </svg>
                        <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#747474" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 19c-7 0-11-7-11-7a18.45 18.45 0 0 1 5.06-5.94"/>
                          <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 7 11 7a18.5 18.5 0 0 1-2.16 2.88"/>
                          <line x1="1" y1="1" x2="23" y2="23"/>
                          <path d="M14.12 14.12A3 3 0 0 1 9.88 9.88"/>
                          <path d="M9.88 14.12a3 3 0 0 0 4.24 0"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="inner-right-container">
                  <div class="submit-container">
                    <button id="password-recover" type="button" @click="changeMenuState(1)">Passwort vergessen</button>
                    <button type="submit">Einloggen</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="footer">
          <div class="footer-first-row">
            <img :src="require('@/assets/footer/Icon-awesome-facebook.svg')" alt="Facebook">
            <img :src="require('@/assets/footer/Icon-awesome-instagram.svg')" alt="Instagram">
            <img :src="require('@/assets/footer/Icon-awesome-linkedin.svg')" alt="linkedIn">
            <img :src="require('@/assets/footer/Icon-simple-xing.svg')" alt="Xing">
            <img :src="require('@/assets/footer/Icon-awesome-youtube.svg')" alt="Youtube">
            <img :src="require('@/assets/footer/Icon-awesome-whatsapp-square.svg')" alt="Whatsapp">
          </div>
          <div class="footer-second-row">
            <img :src="require('@/assets/footer/Sander-Gruppe.png')" alt="Sander-Logo">
          </div>
        </div>
      </div>
      <div v-if="currentForm === 'register'" class="login-container">
        <div class="logo-container">
          <img src="https://sander-gruppe.eu/wp-content/uploads/2019/07/ms-logo.png" alt="Ihr Logo" class="logo">
        </div>
        <div class="outer-container">
          <h3>m&s Elemente Konfigurator - Registrierung</h3>
          <div v-if="registerInfo" class="info-message">
              Die Registrierung war erfolgreich.
          </div>
          <div class="toggle-buttons">
            <button @click="toggleForm('login')">Als Händler einloggen</button>
            <button @click="toggleForm('register')" style="color: #993333;">Neuregistrierung für Händler</button>
          </div>
          <form @submit.prevent="register">
            <div class="inner-container">
              <div class="inner-left-container">
                <div class="input-container">
                  <label for="email">E-Mail:</label>
                  <input id="email" type="email" v-model="email" required>
                </div>
                <div class="input-container">
                  <label for="password">Passwort:</label>
                  <div class="password-wrapper">
                    <input
                      id="password"
                      :type="showPassword ? 'text' : 'password'"
                      v-model="password"
                      required
                    >
                    <button
                      type="button"
                      class="eye-toggle"
                      @click="showPassword = !showPassword"
                      :aria-label="showPassword ? 'Passwort verbergen' : 'Passwort anzeigen'"
                    >
                      <svg v-if="!showPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#747474" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/>
                        <circle cx="12" cy="12" r="3"/>
                      </svg>
                      <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#747474" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 19c-7 0-11-7-11-7a18.45 18.45 0 0 1 5.06-5.94"/>
                        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 7 11 7a18.5 18.5 0 0 1-2.16 2.88"/>
                        <line x1="1" y1="1" x2="23" y2="23"/>
                        <path d="M14.12 14.12A3 3 0 0 1 9.88 9.88"/>
                        <path d="M9.88 14.12a3 3 0 0 0 4.24 0"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div class="inner-right-container">
                <div class="submit-container">
                  <button type="submit">Registrieren</button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <!-- <button @click="deleteAll()">Alle Benutzer löschen</button> -->
        <div class="footer">
          <div class="footer-first-row">
            <img :src="require('@/assets/footer/Icon-awesome-facebook.svg')" alt="Facebook">
            <img :src="require('@/assets/footer/Icon-awesome-instagram.svg')" alt="Instagram">
            <img :src="require('@/assets/footer/Icon-awesome-linkedin.svg')" alt="linkedIn">
            <img :src="require('@/assets/footer/Icon-simple-xing.svg')" alt="Xing">
            <img :src="require('@/assets/footer/Icon-awesome-youtube.svg')" alt="Youtube">
            <img :src="require('@/assets/footer/Icon-awesome-whatsapp-square.svg')" alt="Whatsapp">
          </div>
          <div class="footer-second-row">
            <img :src="require('@/assets/footer/Sander-Gruppe.png')" alt="Sander-Logo">
          </div>
        </div>
      </div>
      <div v-if="isLoading" class="loading-overlay">
        <div class="spinner"></div>
      </div>
    </div>
  </template>
  
  <script>
  import api from '@/api/client';
  import FirstUserPassword from './FirstUserPassword.vue';
  import ForgotPassword from './ForgotPassword.vue';

  export default {
    name: 'LoginPage',
    components: {
        FirstUserPassword,
        ForgotPassword
    },
    data() {
      return {
        menuState: 0,
        kdnr: '',
        email: '',
        password: '',
        showPassword: false,
        loginError: false,
        blockedError: false,
        registerInfo: false,
        currentForm: 'login',
        isLoading: false,
      };
    },
    methods: {
      toggleForm(formType) {
        this.currentForm = formType;
      },
      login() {
        this.loginError = false;
        this.blockedError = false;
        this.isLoading = true;
        api.post('/api/shopusers/login', {
          kdnr: this.kdnr,
          email: this.email,
          password: this.password
        })
        .then(response => {
          // Verarbeiten der Antwort
          this.$parent.setLoggedInUser(response.data.user);
          api.get(`/api/unternehmen/${response.data.user.unternehmen_id}`)
            .then(response => {
              this.$parent.setCompany(response.data);
              api.get(`/api/ansprechpartner/${response.data.ansprechpartner_id}`)
              .then(response => {
                  this.$parent.setContactPerson(response.data);
                  this.isLoading = false;
                  this.$parent.changeMenuState(3); // Bei Erfolg, ändern des Menüstatus
                this.loginError = false;
                this.blockedError = false;
              })
              .catch(error => {
                  this.isLoading = false;
                  this.$parent.changeMenuState(3);
                  console.error('Fehler beim Laden der Ansprechperson: ', error);
              });
            })
            .catch(error => {
                this.isLoading = false;
                console.error('Fehler beim Laden des Unternehmens: ', error);
            });
        })
        .catch(error => {
          // Fehlerbehandlung
          this.isLoading = false;
          console.error(error);
          if (error.response && error.response.status === 403) {
            this.blockedError = true;
            this.loginError = false;
          } else {
            this.loginError = true;
            this.blockedError = false;
          }
        });
      },
      register() {
        api.post('/api/shopusers/register', {
          email: this.email,
          password: this.password
        })
        .then(() => {
          // Verarbeiten der Antwort
          this.registerInfo = true;
        })
        .catch(error => {
          // Fehlerbehandlung
          console.error(error);
          this.registerInfo = false;
        });
      },
      deleteAll() {
        api.delete('/api/shopusers/delete-all', {
          
        })
        .then(response => {
          // Verarbeiten der Antwort
          console.log(response);
        })
        .catch(error => {
          // Fehlerbehandlung
          console.error(error);
        });
      },
      changeMenuState(menuState) {
        this.menuState = menuState;

        if (this.menuState == 1) {
          this.$refs.forgotPasswordComponent.changeMenuState(0);
        }

        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    }
  };
  </script>
  
<style scoped src="@/styles/LoginComponent.css">

</style>
